<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <div class="live-call">
    <visit-call-vvrtc></visit-call-vvrtc>
  </div>
</template>
<!-- eslint-enable -->

<script>
import VisitCallVvrtc from '@/components/vvrtc/VisitCallVvrtc.vue';

export default {
  components: {
    VisitCallVvrtc,
  },
  props: {},
  data() {
    return {
      test: '',
    };
  },
  mounted() {

  },
  methods: {

  },
};
</script>
